import type { GalleryPreset } from "../types";

export const researchPublicationsPresets: GalleryPreset[] = [
  {
    presetId: "monograph-first",
    presetVersion: 1,
    name: "Monograph First",
    tagline: "Dense, distraction-free citation chronology built for prolific scholars",
    category: "research-publications",
    filters: {
      purpose: "publication-first",
      aesthetic: "minimal",
      contentEmphasis: ["publications"],
      userStage: "professor",
    },
    intendedAudience: "Prolific book and journal authors across STEM and humanities",
    requiredTier: "starter",
    thumbnailUrl: "/thumbnails/monograph-first.webp",
    structureId: "faculty-linear",
    themeId: "theme-swiss-monochrome",
    blueprintId: "blueprint-research-showcase",
    demoDataId: "persona-dr-chen",
  },
  {
    presetId: "cyber-laboratory",
    presetVersion: 1,
    name: "Cyber Laboratory",
    tagline: "Dark data-dense layout with code repository cards and monospace accents",
    category: "research-publications",
    filters: {
      purpose: "research-showcase",
      aesthetic: "technical",
      contentEmphasis: ["projects", "publications", "skills"],
      userStage: "research-lab",
    },
    intendedAudience: "Systems, AI/ML, and computational scientists with open-source tools",
    requiredTier: "pro",
    thumbnailUrl: "/thumbnails/cyber-laboratory.webp",
    structureId: "bento-grid",
    themeId: "theme-cyber-technical",
    blueprintId: "blueprint-research-showcase",
    demoDataId: "persona-dr-brooks",
    isFeatured: true,
  },
  {
    presetId: "aurora-discovery",
    presetVersion: 1,
    name: "Aurora Discovery",
    tagline: "Luminous showcase grid highlighting research figures, imaging, and grants",
    category: "research-publications",
    filters: {
      purpose: "research-showcase",
      aesthetic: "modern",
      contentEmphasis: ["projects", "publications"],
      userStage: "professor",
    },
    intendedAudience: "Experimentalists, bioengineers, and interdisciplinary scientists",
    requiredTier: "pro",
    thumbnailUrl: "/thumbnails/aurora-discovery.webp",
    structureId: "showcase-portfolio",
    themeId: "theme-aurora-vibrant",
    blueprintId: "blueprint-research-showcase",
    demoDataId: "persona-dr-morrison",
  },
  {
    presetId: "research-group-hub",
    presetVersion: 1,
    name: "Research Group Hub",
    tagline: "Multi-page research group portal featuring team rosters and program grants",
    category: "research-publications",
    filters: {
      purpose: "lab-group",
      aesthetic: "modern",
      contentEmphasis: ["projects", "experience", "publications"],
      userStage: "research-lab",
    },
    intendedAudience: "Principal Investigators, research centers, and collaborative labs",
    requiredTier: "premium",
    thumbnailUrl: "/thumbnails/research-group-hub.webp",
    structureId: "showcase-portfolio",
    themeId: "theme-sapphire-modern",
    blueprintId: "blueprint-research-showcase",
    demoDataId: "persona-dr-morrison",
    isFeatured: true,
  },
  {
    presetId: "science-communicator",
    presetVersion: 1,
    name: "Science Communicator",
    tagline: "Magazine editorial spread connecting research papers to public outreach",
    category: "research-publications",
    filters: {
      purpose: "research-showcase",
      aesthetic: "editorial",
      contentEmphasis: ["media", "publications"],
      userStage: "science-communicator",
    },
    intendedAudience: "Public scholars, book authors, and science communicators",
    requiredTier: "starter",
    thumbnailUrl: "/thumbnails/science-communicator.webp",
    structureId: "editorial-split",
    themeId: "theme-botanical-warm",
    blueprintId: "blueprint-research-showcase",
    demoDataId: "persona-dr-vasquez",
  },
  {
    presetId: "data-commons",
    presetVersion: 1,
    name: "Data Commons",
    tagline: "Structured software and benchmark dashboard for computational scientists",
    category: "research-publications",
    filters: {
      purpose: "research-showcase",
      aesthetic: "minimal",
      contentEmphasis: ["projects", "publications", "skills"],
      userStage: "professor",
    },
    intendedAudience: "Bioinformaticians, data curators, and benchmark developers",
    requiredTier: "pro",
    thumbnailUrl: "/thumbnails/data-commons.webp",
    structureId: "bento-grid",
    themeId: "theme-swiss-monochrome",
    blueprintId: "blueprint-research-showcase",
    demoDataId: "persona-dr-brooks",
  },
];
